var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefineMessageDisableButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_83707",
    "data-name": "Path 83707",
    d: "M16.6,8.6a1.209,1.209,0,0,0-1.2-1.2H8.2a1.2,1.2,0,0,0,0,2.4h4.3l-4.74,4.74a1.2,1.2,0,1,0,1.7,1.7L14.2,11.5v4.3a1.2,1.2,0,1,0,2.4,0ZM12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z",
    fill: "#a0a0a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefineMessageDisableButtonIcon);
export default __webpack_public_path__ + "static/media/refine-message-disable-button-icon.fab81bb74222c90283304fd603926a38.svg";
export { ForwardRef as ReactComponent };